import * as React from 'react';
import {
  ChildItem,
  ChildLink,
  Glyphicon,
  MenuItem,
  MenuLink,
  MenuList,
  MenuListContainer
} from './MenuList.style';
import { Collapse } from 'reactstrap';
import Feedback from 'components/pages/Feedback/FeedbackContainer';
import PropTypes from 'prop-types';

/**
 * Side Menu List of Links
 *
 * @param {Object} props All the properties passed to the React Component.
 * @param {function} props.toggleMenu The function that is called when the user clicks to toggle menu
 * @param {array} props.menu An array of menu items
 * @param {string} props.pathname Current router pathname
 * @param {url} props.url Current router Url
 * @returns {StatelessComponent} Stateless functional React component.
 */

export const MenuListComponent = ({ toggleMenu, menu, pathname, url }) => (
  <MenuListContainer className="onboarding-tour menu-list-container">
    <MenuList>
      {menu.map(({ link, icon, title, children }, index) => (
        <div key={index}>
          <MenuItem>
            <MenuLink to={`${url}/${link}`} onClick={() => toggleMenu(false)}>
              <Glyphicon src={icon} alt={title} />
              {title}
            </MenuLink>
          </MenuItem>
          <Collapse isOpen={pathname.includes(`${url}/${link}`)}>
            {children.map(({ link: childLink, title: childTitle }, index) => (
              <ChildItem key={`child-${index}`}>
                <ChildLink
                  to={`${url}/${link}/${childLink}`}
                  onClick={() => toggleMenu(false)}
                >
                  <Glyphicon src="" />
                  {childTitle}
                </ChildLink>
              </ChildItem>
            ))}
          </Collapse>
        </div>
      ))}
    </MenuList>
    <Feedback />
  </MenuListContainer>
);

MenuListComponent.propTypes = {
  toggleMenu: PropTypes.func.isRequired,
  menu: PropTypes.array.isRequired,
  pathname: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired
};

MenuListComponent.contextTypes = {
  t: PropTypes.func.isRequired
};

export default MenuListComponent;



// WEBPACK FOOTER //
// ./src/components/common/SideMenu/MenuList/MenuListComponent.js